import { PATH_SEGMENT } from 'routes/pathSegments'

// The calendar locks page scrolling; the Series pages under /schedule/series scroll normally.
export const isSchedulePagePath = (segments: string[]): boolean =>
  segments[1]?.toLowerCase() === PATH_SEGMENT.SCHEDULE &&
  segments[2]?.toLowerCase() !== PATH_SEGMENT.SERIES
